export enum FeccPosition {
    Privacy = 'privacy',
    Home = 'home',
}
